<template>
  <div
    class="monitor"
    style="font-size: 16px; width: 100%; background: #eff1f5"
  >
    <div class="content">
      <div class="yuliang" ref="yuliang" style="margin-top: 0">
        <div class="select clearfix" ref="districtrainOperation">
          <span id="export" @click="exportDocx">
            <span class="export-icon" ref="downloadArea"></span>导出
          </span>
        </div>
        <div class="tableDiv" ref="tableDiv" v-loading = "loading">
          <div class='tinymce' style="width:100%;height:100%" >
          <editor id='tinymce' v-model='tinymceHtml' :init="init"></editor>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import htmlDocx from 'html-docx-js/dist/html-docx' // html转word
import saveAs from 'file-saver'
import tinymce from 'tinymce/tinymce.min.js'
// import 'tinymce/themes/silver/theme'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/print'
import 'tinymce/icons/default/icons'
import reportAnalysisTypes from '@/store/types/reportAnalysis'
export default {
  name: 'tinymce',
  data () {
    return {
      loading: true,
      query: {
        addvcd: '330324',
        begTime: ''
      },
      currentYear: '',
      tinymceHeight: 700,
      tdata: [],
      tinymceHtml: '',
      showTrData: '',
      tableFrame: '',
      showTime: '',
      titleTime: '',
      nextText: [], // 下一步措施
      nextTextFrame: '',
      rainList: [], // 雨情
      rainListFrame: '',
      waterAnalysis: [], // 水情分析
      waterAnalysisFrame: '',
      waterList: [], // 水情
      waterListFrame: '',
      init: {
        selector: '.tinymce',
        language_url: 'tinymce/zh_CN.js',
        language: 'zh_CN',
        skin_url: 'tinymce/skins/ui/oxide', // 皮肤引入错误可能不显示
        content_css: 'tinymce/water_rain_briefing.css', // 内联模式引入css
        auto_focus: false,
        height: '100%',
        plugins: 'print link lists image code table colorpicker textcolor wordcount contextmenu',
        toolbar:
          'print bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat',
        branding: false,
        inline: false
        // menubar: false
      }
    }
  },
  components: {
    Editor
  },
  methods: {
    getShowDataTr () { // 富文本内页面拼接
      this.tinymceHtml = ` <div class="table-content" style= "height:2000px">
            <p style="margin: 12px auto 0; display: block; text-align: center; font-weight: bold; font-size: 24pt; color: #f60;">永嘉县汛情简报</p>
            <p style="margin: 10px auto 0; display: block; text-align: center; font-size: 18pt; font-weight: bold;">(${this.currentYear}年第xx期)</p>
            <p style="border-bottom: 2px solid #f60; padding-bottom: 7px;"><span style="margin-left: 20px; font-size: 14pt; font-weight: 500; color: #f60;">永嘉县水利局</span><span style="float: right; margin-right: 20px; font-size: 14pt; font-weight: 500; color: #333;">${this.titleTime}</span></p>
            <p style="padding: 8px; font-size: 16pt; font-weight: 500; height: 30px; margin-bottom: 15px; margin-top: 20px;">一、汛情单</p>
            <table style="width: 100%; background: white; border-collapse: collapse; margin-top: -10px;">
            <tbody>
            <tr class="firstRow" style="background: #b0c0d5;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">名称</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;" colspan="3" rowspan="1">内容</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">正常值(警戒值)</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">${this.showTime}</td>
            </tr>
            ${this.rainListFrame}
            ${this.waterListFrame}
            <tbody>
            </table>
             ${this.waterAnalysisFrame}
             ${this.nextTextFrame}
            <div>
            `
    },
    tabledata () {
      this.loading = true
      this.$store
        .dispatch(reportAnalysisTypes.WATER_RAIN_BRIEFING)
        .then(data => {
          this.rainList = data.data.rainList
          this.waterAnalysis = data.data.waterAnalysis
          this.waterList = data.data.waterList
          this.nextText = data.data.nextText
          this.rainList.forEach(el => { // 雨情
            this.rainListFrame += `<tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.name}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" colspan="3" rowspan="1">${el.content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.value}</td>
            </tr>`
          })
          // 判断type类型个数,表格合并拼接
          var overAll = this.waterList.filter(el => {
            return el.type === '总体情况'
          })
          var bigMid = this.waterList.filter(el => {
            return el.type === '大中型水库'
          })
          var smallOne = this.waterList.filter(el => {
            return el.type === '小（一）水库'
          })
          var smallTwo = this.waterList.filter(el => {
            return el.type === '小（二）水库'
          })
          var waterLevel = this.waterList.filter(el => {
            return el.type === '水位'
          })
          // 总体情况
          this.waterListFrame += ` 
          <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" rowspan="${this.waterList.length}">${this.waterList[0].name}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"rowspan="${overAll.length}" colspan ="2">${overAll[0].type}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${overAll[0].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${overAll[0].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${overAll[0].value}</td>
            </tr>
            `
          for (let i = 1; i < overAll.length; i++) { // 总体情况
            this.waterListFrame += ` <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${overAll[i].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${overAll[i].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${overAll[i].value}</td>
            </tr>`
          }
          // 大中型水库
          this.waterListFrame += ` 
          <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"rowspan="${bigMid.length}" colspan ="2">${bigMid[0].type}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${bigMid[0].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${bigMid[0].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${bigMid[0].value}</td>
            </tr>
            `
          for (let i = 1; i < bigMid.length; i++) { // 大中型水库
            this.waterListFrame += ` <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${bigMid[i].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${bigMid[i].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${bigMid[i].value}</td>
            </tr>`
          }
          // 小一型水库
          this.waterListFrame += ` 
          <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"rowspan="${smallOne.length}" colspan ="2">${smallOne[0].type}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallOne[0].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallOne[0].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallOne[0].value}</td>
            </tr>
            `
          for (let i = 1; i < smallOne.length; i++) { // 小一型
            this.waterListFrame += ` <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallOne[i].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallOne[i].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallOne[i].value}</td>
            </tr>`
          }
          // 小二型水库
          this.waterListFrame += ` 
          <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"rowspan="${smallTwo.length}" colspan ="2">${smallTwo[0].type}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallTwo[0].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallTwo[0].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallTwo[0].value}</td>
            </tr>
            `
          for (let i = 1; i < smallTwo.length; i++) { // 小二型
            this.waterListFrame += ` <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallTwo[i].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallTwo[i].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${smallTwo[i].value}</td>
            </tr>`
          }
          // 水位
          this.waterListFrame += ` 
          <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"rowspan="${waterLevel.length}" colspan ="2">${waterLevel[0].type}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${waterLevel[0].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${waterLevel[0].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${waterLevel[0].value}</td>
            </tr>
            `
          for (let i = 1; i < waterLevel.length; i++) { // 水位
            this.waterListFrame += ` <tr>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${waterLevel[i].content}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${waterLevel[i].warnValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${waterLevel[i].value}</td>
            </tr>`
          }
          // this.waterListFrame += `
          // <tr>
          //   <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" rowspan="${this.waterList.length}">${this.waterList[0].name}</td>
          //   <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"rowspan="${this.waterList.length}" colspan ="2">${this.waterList[0].type}</td>
          //   <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.waterList[0].content}</td>
          //   <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.waterList[0].warnValue}</td>
          //   <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.waterList[0].value}</td>
          //   </tr>
          //   `
          // for (let i = 1; i < this.waterList.length; i++) { // 水情
          //   this.waterListFrame += ` <tr>
          //   <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.waterList[i].content}</td>
          //   <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.waterList[i].warnValue}</td>
          //   <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.waterList[i].value}</td>
          //   </tr>`
          // }
          // 水雨情分析
          this.waterAnalysisFrame = ` <p style="padding: 8px; font-size: 16pt; font-weight: 500; height: 30px; margin-bottom: 15px; margin-top: 20px;">二、水雨情分析</p>`
          this.waterAnalysis.forEach(el => {
            this.waterAnalysisFrame += ` <p style="font-size: 14pt; text-indent: 25px; margin-top: -10px;">${el}</p>`
          })
          // 下一步措施
          this.nextTextFrame += `<p style="padding: 8px; font-size: 16pt; font-weight: 500; height: 30px; margin-bottom: 15px; margin-top: 20px;">三、下一步措施</p>`
          this.nextText.forEach(el => {
            this.nextTextFrame += `<p style="font-size: 14pt; text-indent: 25px; margin-top: -10px;">${el}</p>`
          })
          this.loading = false
          this.getShowDataTr()
        })
    },
    // 转换图片为 base64 (todo: 有可能因跨域报错)
    convertImagesToBase64 (contentDocument) {
      // 找到所有的图片
      let imgs = contentDocument.querySelectorAll('img')
      // 图片转换用
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      imgs.forEach((img, i) => {
        if (img.src.startsWith('data:image')) return
        // img表现尺寸
        let realWidth = parseInt(img.style.width)
        let realHeight = parseInt(img.style.height)

        // 清空画布并调整为 img 的大小
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        canvas.width = realWidth
        canvas.height = realHeight
        // 画图片到画布
        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          realWidth,
          realHeight
        )
        // ctx.drawImage(img, 0, 0);

        // 画布转为 base64
        let dataURL = canvas.toDataURL()
        img.setAttribute('src', dataURL)
      })

      canvas.remove()
    },
    convertChartsToBase64 (contentDocument) {
      // 找到所有的图表 （echart）
      let canvases = contentDocument.querySelectorAll('canvas')
      // 遍历图表，转换为 base64 静态图片
      canvases.forEach((canvas, i) => {
        let echart = this.$refs.chart[i]
        let url = echart.getDataURL()
        let img = document.createElement('img')
        img.src = url
        canvas.parentNode.replaceChild(img, canvas)
      })
    },
    // 生成下载链接
    createDownloadLink (fileObj, fileName) {
      let link = document.createElement('a')
      link.href = URL.createObjectURL(fileObj)
      link.download = fileName || 'document.docx'
      link.appendChild(document.createTextNode(''))
      return link
    },
    exportDocx () {
      // 获取页面dom元素
      let contentDocument = this.tinymceHtml
      let content = `<!DOCTYPE html>
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
            </head>
            <body>
                ${contentDocument}
            </body>
            </html>`
      let converted = htmlDocx.asBlob(content)
      saveAs(converted, '水雨情简报.docx')
      let link = this.createDownloadLink(converted, '水雨情简报.docx')
      this.$refs.downloadArea.innerHTML = ''
      this.$refs.downloadArea.appendChild(link)
    }
  },
  created () {
    let myDate = new Date()
    this.currentYear = myDate.getFullYear()
    this.titleTime = myDate.getFullYear() + '年' + (myDate.getMonth() + 1) + '月' + myDate.getDate() + '日'
    this.showTime = (myDate.getMonth() + 1) + '月' + myDate.getDate() + '日' + myDate.getHours() + '时'
  },
  mounted () {
    tinymce.init({})
    this.tabledata()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - 30 + 'px'
      let selectHeight = this.$refs.districtrainOperation.offsetHeight
      this.$refs.tableDiv.style.height = this.$refs.yuliang.offsetHeight - selectHeight - 30 + 'px'
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped></style>
<style lang="less" scoped>
.yuliang {
   /deep/ .tableDiv{
      margin-top: 15Px;
      width:98%;
      margin-left: 1%;
      overflow: auto;
      padding-top: 10px;
    }
}
</style>
